/**
 * This file is part of the "Awaken Media project.
 *
 * (c) 2018 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export const getFormattedApis = content => ({
  categoriesListApiUrl: content.apis['legacy_vod.categories_list'].url,
  categoryApiUrl: content.apis['legacy_vod.category'].url
});

export default (content, { getLinkHrefWithAuthentication }) => ({
  ...getFormattedApis(content),
  folderUrl: getLinkHrefWithAuthentication(content.links.folder),
  detailUrl: getLinkHrefWithAuthentication(content.links.detail),
  categoryUrl: getLinkHrefWithAuthentication(content.links.category)
});
